import EnvioInventarioService from "@/services/inventario/EnvioInventarioService";

const fetch = (context, params) => {
  return EnvioInventarioService.fetch(params)
    .then(res => {
      context.commit('ENVIO_INVENTARIO', res.data);
    });
};

export default {
  fetch,
};